<template>
  <button @click="openModal" :class="['explanation-btn button-as-link', { 'icon-btn': withIcon, 'no-underline': withIcon }]">
    <img v-if="withIcon" :src="InfoIcon" alt="An information icon." />
    {{ buttonText }}
  </button>
</template>

<script setup lang="ts">
import { useModal } from 'vue-final-modal';
import ModalCentered from './ModalCentered.vue';
import InfoIcon from '@/assets/img/calculation-info.svg';
import { AnalyticsEvents, AnalyticsEventTypes } from '../../foundation/enums/AnalyticsEvents';
import { useCarComparisonStore } from '../../foundation/stores/carComparisonStore';
import { useRoute } from 'vue-router';
const props = defineProps({
  title: {
    type: String,
    default: 'Title',
  },
  description: {
    type: String,
    default: 'Description',
  },
  buttonText: {
    type: String,
    default: '',
  },
  withIcon: {
    type: Boolean,
    default: false,
  },
});
const carComparisonStore = useCarComparisonStore();
const route = useRoute();
const estimatedModal = useModal({ component: ModalCentered });
function pushToAnalytics() {
  try {
    carComparisonStore.pushToAnalytics(route.params.carId as string, AnalyticsEvents.NavigationLinkClick, props.title, AnalyticsEventTypes.ExplanationLink);
  } catch (error) {
    console.log('fail to push to analytics', error);
  }
}
function openModal() {
  estimatedModal.options.attrs = {
    title: props.title,
    onClose: () => estimatedModal.close(),
  };
  estimatedModal.options.slots = {
    default: props.description,
  };
  pushToAnalytics();
  estimatedModal.open();
}
</script>

<style lang="scss" scoped>
.explanation-btn {
  font-size: 0.875rem;
}
</style>
